import Input from "./Input";
import Select from "./Select";
import Checkbox from "./Checkbox";
import Button from "./Button";
import MultiSelect from "./MultiSelect";
import AutocompleteSelect from "./AutocompleteSelect";

const Controls = {
    Input,
    Select,
    Checkbox,
    Button,
    MultiSelect,
    AutocompleteSelect
}

export default Controls;